import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import stationDataReducer from './station-data/station-data.reducer';
import userReducer from './user/user.reducer';

const rootPersistConfig = {
  "key": 'root',
  storage,
  "blacklist": ['user']
};

const userPersistConfig = {
  key: 'user',
  storage: storage,
  blacklist: ['uniqueMapId', 'alertMessage']
}

const rootReducer = combineReducers({
  "stationData": stationDataReducer,
  "user": persistReducer(userPersistConfig, userReducer)
});

export default persistReducer(rootPersistConfig, rootReducer);